import { create_requisition_drawer_from_row } from './procurement_compliance_drawer_helpers';

const category_status_map = {
  'On plan': 'bg-success-subtle text-success-emphasis',
  'Off plan': 'bg-warning-subtle text-warning-emphasis',
  Watch: 'bg-info-subtle text-info-emphasis'
};

const eligibility_map = {
  Eligible: 'bg-success-subtle text-success-emphasis',
  Ineligible: 'bg-danger-subtle text-danger-emphasis',
  Pending: 'bg-warning-subtle text-warning-emphasis'
};

const requisition_status_map = {
  Compliant: 'bg-success-subtle text-success-emphasis',
  'In progress': 'bg-warning-subtle text-warning-emphasis',
  Pending: 'bg-warning-subtle text-warning-emphasis',
  'Non-compliant': 'bg-danger-subtle text-danger-emphasis',
  Irregular: 'bg-danger-subtle text-danger-emphasis'
};

const irregularity_badge_map = {
  Breach: 'bg-danger-subtle text-danger-emphasis',
  Cleared: 'bg-success-subtle text-success-emphasis',
  Watch: 'bg-info-subtle text-info-emphasis',
  Irregular: 'bg-warning-subtle text-warning-emphasis'
};

const irregularity_icon_map = {
  'Split-order detection': 'bi-diagram-3',
  'Supplier concentration': 'bi-people',
  'Irregular expenditure': 'bi-exclamation-triangle',
  'Threshold breach': 'bi-flag'
};

export const deep_clone = (value) => JSON.parse(JSON.stringify(value));
export const number_from_currency = (value) => Number(String(value || '').replace(/[^\d]/g, '')) || 0;
export const currency_from_number = (value) => `R ${Number(value || 0).toLocaleString('en-ZA')}`;

export function category_status_class(label) {
  const status_class = Reflect.get(category_status_map, label) ?? Reflect.get(category_status_map, 'On plan');
  return status_class;
}

export function eligibility_badge_class(label) {
  const badge_class = Reflect.get(eligibility_map, label) ?? Reflect.get(eligibility_map, 'Eligible');
  return badge_class;
}

export function requisition_status_class(label) {
  const status_class = Reflect.get(requisition_status_map, label) ?? Reflect.get(requisition_status_map, 'Compliant');
  return status_class;
}

export function irregularity_badge_class(severity) {
  const badge_class = Reflect.get(irregularity_badge_map, severity) ?? Reflect.get(irregularity_badge_map, 'Irregular');
  return badge_class;
}

export function irregularity_icon_class(type) {
  const icon_class = Reflect.get(irregularity_icon_map, type) ?? Reflect.get(irregularity_icon_map, 'Split-order detection');
  return icon_class;
}

export const create_category_form = () => ({ category: '', planned_budget: '', committed_to_date: '', status: 'On plan' });
export const create_rule_form = () => ({ value_band: '', required_method: '', approver: '', required_evidence: '' });
export const create_requisition_form = () => ({ requisition: '', department: '', value: '', procurement_method: 'Single quote', threshold_band: '<= R 2k', stage: '', selected_supplier: '', supplier_eligibility: 'Eligible', compliance_status: 'Compliant', note: '' });
export const create_bid_form = () => ({ requisition: '', committee: 'Bid Specification (BSC)', chairperson: '', declarations: '', evaluation: '', recommendation: '', status: 'In progress' });
export const create_award_form = () => ({ supplier: '', requisition: '', value: '', method: 'Single quote', approved_by: '', date: '', status: 'Awarded' });
export const create_deviation_form = () => ({ title: '', type: 'Deviation', value: '', justification: '', approved_by: '', date: '', status: 'Approved' });
export const create_irregularity_form = () => ({ flag: '', type: 'Split-order detection', value: '', detail: '', severity: 'Irregular', status: 'Open' });

export { create_requisition_drawer_from_row };
